import { useStore } from 'vuex'
// 检查权限列表


const checkPermission = function(list){
	// 获取 token
	let store = useStore()
	const permissions = store.state.user.permissions
	let flag = false
	list.forEach((item)=>{
		if(permissions.indexOf(item)!=-1){
			flag = true
		}
	})
	return flag
}

export default checkPermission;